import { render, staticRenderFns } from "./SortLabel.vue?vue&type=template&id=0f36b6fd&scoped=true"
import script from "./SortLabel.vue?vue&type=script&lang=js"
export * from "./SortLabel.vue?vue&type=script&lang=js"
import style0 from "./SortLabel.vue?vue&type=style&index=0&id=0f36b6fd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f36b6fd",
  null
  
)

export default component.exports